export interface SuspensionReason {
  id: number;
  code: string;
  name: string;
  message?: string | null;
}

export interface SuspensionUser {
  id: number;
  username?: string;
  email?: string;
}

export interface TaxPayerSuspension {
  id: number;
  taxPayerId: number;
  suspensionReasonId: number;
  reasonCode?: string;
  reasonName?: string;
  notes?: string | null;
  suspendedAt: string;
  suspendedBy?: SuspensionUser | null;
  liftedAt?: string | null;
  liftedBy?: SuspensionUser | null;
  liftNotes?: string | null;
}

export interface TaxPayerSuspensionsData {
  active: TaxPayerSuspension | null;
  items: TaxPayerSuspension[];
  count: number;
}

export const suspensionUserLabel = (user?: SuspensionUser | null) =>
  user ? user.username || user.email || `#${user.id}` : "-";
